/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request to create a new visit form draft.
 * @export
 * @interface CreateVisitFormRequest
 */
export interface CreateVisitFormRequest {
    /**
     * Property address for the visit
     * @type {string}
     * @memberof CreateVisitFormRequest
     */
    propertyAddress: string;
    /**
     * Refresh flag
     * @type {boolean}
     * @memberof CreateVisitFormRequest
     */
    isRefresh: boolean;
}

/**
 * Check if a given object implements the CreateVisitFormRequest interface.
 */
export function instanceOfCreateVisitFormRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "propertyAddress" in value;
    isInstance = isInstance && "isRefresh" in value;

    return isInstance;
}

export function CreateVisitFormRequestFromJSON(json: any): CreateVisitFormRequest {
    return CreateVisitFormRequestFromJSONTyped(json, false);
}

export function CreateVisitFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateVisitFormRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'propertyAddress': json['property_address'],
        'isRefresh': json['is_refresh'],
    };
}

export function CreateVisitFormRequestToJSON(value?: CreateVisitFormRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'property_address': value.propertyAddress,
        'is_refresh': value.isRefresh,
    };
}

